import './index.scss';
import './event-bus';
import './ecommerce';
import './social-sharing';
import './hide-element';
import './format-modal';
import './toggle-text';
import './social-impact';
import './general';
import './add-to-cart';
import './flyout-cart';
import ZolaGa from '../../components/zola-google-analytics';
import '../../components/mailchimp-signup-options/index';
import '../../components/fb-chatbot/index';

const zolaGa = new ZolaGa();
zolaGa.init();
